/**
 * Created by renlaydel on 02/11/2017.
 */
import * as SagasType from '../constants/constant_saga_types';
import * as ActionType from '../constants/constant_action_types';

export function getPurchaseOrderReorder(locationId, supplierId) {
  return { type: SagasType.GET_PURCHASE_ORDER_REORDER, locationId, supplierId };
}

export function fetchPurchaseOrderList( silent, filters ) {
  return { type: SagasType.FETCH_LIST_PURCHASE_ORDER, silent, filters };
}

export function getPurchaseOrder( id ) {
  return { type: SagasType.GET_PURCHASE_ORDER, id };
}

export function savePurchaseOrder( data, redirectToView ){
  return { type: SagasType.SAVE_PURCHASE_ORDER, data, redirectToView };
}

export function getPurchaseOrderLineItemLocation( locationId, itemId, index, itemUom ){
  return { type: SagasType.GET_PURCHASE_ORDER_LINE_ITEM_LOCATION, locationId, itemId, index, itemUom };
}

export function getAllPurchaseOrderLinesItemLocation(locationId){
  return { type: SagasType.GET_ALL_PURCHASE_ORDER_LINES_ITEM_LOCATION, locationId };
}

export function clearPurchaseOrder(){
  return { type: ActionType.CLEAR_PURCHASE_ORDER };
}

export function getPurchaseOrderLineTaxGroup( taxGroup, index ){
  return { type: SagasType.GET_PURCHASE_ORDER_LINE_TAX_GROUP, taxGroup, index };
}

export function getPurchaseOrderExchangeRate( currencyFromId, currencyToId, date ){
  return { type: SagasType.GET_PURCHASE_ORDER_EXCHANGE_RATE, currencyFromId, currencyToId, date };
}

export function generatePurchaseReceipt( generateReceipt ){
  return { type: ActionType.GENERATE_PURCHASE_RECEIPT, generateReceipt };
}

export function generatePurchaseReceiptData( generateReceipt, data ){
  return { type: SagasType.GENERATE_PURCHASE_RECEIPT_DATA, generateReceipt, data };
}





export function fetchPurchaseReceiptList( silent, filters ) {
  return { type: SagasType.FETCH_LIST_PURCHASE_RECEIPT, silent, filters };
}

export function setPurchaseReceipt( data ) {
  return { type: ActionType.SET_PURCHASE_RECEIPT, data };
}

export function getPurchaseReceipt( id ) {
  return { type: SagasType.GET_PURCHASE_RECEIPT, id };
}

export function savePurchaseReceipt( data, redirectToView ){
  return { type: SagasType.SAVE_PURCHASE_RECEIPT, data, redirectToView };
}

export function getPurchaseReceiptLineItemLocation( locationId, itemId, index, itemUom ){
  return { type: SagasType.GET_PURCHASE_RECEIPT_LINE_ITEM_LOCATION, locationId, itemId, index, itemUom };
}

export function getAllPurchaseReceiptLinesItemLocation(locationId){
  return { type: SagasType.GET_ALL_PURCHASE_RECEIPT_LINES_ITEM_LOCATION, locationId };
}

export function clearPurchaseReceipt(){
  return { type: ActionType.CLEAR_PURCHASE_RECEIPT };
}

export function getPurchaseReceiptLineTaxGroup( taxGroupId, index ){
  return { type: SagasType.GET_PURCHASE_RECEIPT_LINE_TAX_GROUP, taxGroupId, index };
}

export function getPurchaseReceiptExchangeRate( currencyFromId, currencyToId, date ){
  return { type: SagasType.GET_PURCHASE_RECEIPT_EXCHANGE_RATE, currencyFromId, currencyToId, date };
}

export function generatePurchaseReturn( generateReturn ){
  return { type: ActionType.GENERATE_PURCHASE_RETURN, generateReturn };
}

export function openPurchaseReceiptReferenceIdModal( state, header, index, item_line ){
  return { type: ActionType.OPEN_PURCHASE_RECEIPT_REFERENCE_ID_MODAL, state, header, index, item_line };
}

export function generatePurchaseReturnData( generateReturn, data ) {
  return { type: SagasType.GENERATE_PURCHASE_RETURN_DATA, generateReturn, data };
}





export function fetchInventoryReturnList( silent, filters ) {
  return { type: SagasType.FETCH_LIST_INVENTORY_RETURN, silent, filters };
}

export function getInventoryReturn( id ) {
  return { type: SagasType.GET_INVENTORY_RETURN, id };
}

export function saveInventoryReturn( data, redirectToView ){
  return { type: SagasType.SAVE_INVENTORY_RETURN, data, redirectToView };
}

export function clearInventoryReturn(){
  return { type: ActionType.CLEAR_INVENTORY_RETURN };
}

export function getInventoryReturnLineItemLocation( locationId, itemId, index, itemUom ){
  return { type: SagasType.GET_INVENTORY_RETURN_LINE_ITEM_LOCATION, locationId, itemId, index, itemUom };
}

export function getAllInventoryReturnLinesItemLocation( locationId ){
  return { type: SagasType.GET_ALL_INVENTORY_RETURN_LINES_ITEM_LOCATION, locationId };
}

export function getInventoryReturnLineTaxGroup( taxGroupId, index ){
  return { type: SagasType.GET_INVENTORY_RETURN_LINE_TAX_GROUP, taxGroupId, index };
}

export function getInventoryReturnExchangeRate( currencyFromId, currencyToId, date ){
  return { type: SagasType.GET_INVENTORY_RETURN_EXCHANGE_RATE, currencyFromId, currencyToId, date };
}

export function openPurchaseReturnReferenceIdModal( state, header, index ){
  return { type: ActionType.OPEN_PURCHASE_RETURN_REFERENCE_ID_MODAL, state, header, index };
}
